/* Pure selection, allocation matching and cart payloads. No network calls. */
(function (root) {
  'use strict';
  const discounts = { 1: 10, 2: 15, 3: 20 };
  const initial = () => ({ mode: 'subscription', quantity: 2, months: 2 });
  function select(state, action, value) {
    if (action === 'mode') return value === 'subscription' ? initial() : { mode: 'onetime', quantity: 1, months: null };
    if (action === 'quantity') {
      const quantity = Number(value);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return state;
      // Box choices default to their matching cadence; shoppers can override it afterward.
      // Quantities above the three displayed choices retain the selected cadence.
      return { ...state, quantity, months: state.mode === 'subscription' && quantity <= 3 ? quantity : state.months };
    }
    if (action === 'months' && state.mode === 'subscription' && [1, 2, 3].includes(Number(value))) return { ...state, months: Number(value) };
    return state;
  }
  function price(state, unitPrice = 4500) {
    const discount = state.mode === 'subscription' ? discounts[Math.min(state.quantity, 3)] : 0;
    if (discount === undefined) return null;
    const unit = Math.round(unitPrice * (100 - discount) / 100);
    return { unit, total: unit * state.quantity, compare: unitPrice * state.quantity, discount };
  }
  function resolvePlan(plans, quantity, months) {
    if (!Array.isArray(plans) || !Number.isSafeInteger(quantity) || quantity < 1) return null;
    const tier = Math.min(quantity, 3);
    const matches = plans.filter(plan => {
      if (!Array.isArray(plan.options)) return false;
      const quantities = plan.options.filter(option => option.name === 'Product Quantity');
      const frequencies = plan.options.filter(option => option.name === 'Order Frequency and Unit');
      return quantities.length === 1 && frequencies.length === 1 &&
        String(quantities[0].value) === String(tier) && frequencies[0].value === `${months}-month`;
    });
    if (matches.length !== 1) return null;
    const plan = matches[0];
    return Number.isSafeInteger(plan.id) && plan.id > 0 && Number.isSafeInteger(plan.price) && plan.price >= 0 ? plan : null;
  }
  function cartItem(state, data) {
    if (!data || !Number.isSafeInteger(data.variant_id) || data.variant_id <= 0 ||
        !Number.isSafeInteger(state.quantity) || state.quantity < 1) return null;
    const item = { id: data.variant_id, quantity: state.quantity };
    if (state.mode === 'onetime') return data.requires_selling_plan === false ? item : null;
    if (state.mode !== 'subscription' || ![1, 2, 3].includes(state.months)) return null;
    const plan = resolvePlan(data.plans, state.quantity, state.months);
    return plan ? { ...item, selling_plan: plan.id } : null;
  }
  const api = { initial, select, price, resolvePlan, cartItem };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.TeaTierModel = Object.freeze(api);
})(typeof window === 'undefined' ? globalThis : window);
